import React from "react";
import OperationalResource from "../components/OperationalResource";
export default function Positions() {
  return <OperationalResource title="Positions" resource="positions" />;
}
